import type { StandardTextFieldProps, TextFieldProps as MuiTextFieldProps } from '@material-ui/core/TextField';
import TextField from '@material-ui/core/TextField';
import { useFormikContext } from 'formik';
import React, { useCallback } from 'react';
import { Hint } from 'v2/components/Shared/Hint';
import moneyNoSymbolMask from 'v2/components/Shared/Masks/moneyNoSymbol';

export type CurrencyFormFieldProps = Omit<StandardTextFieldProps, 'ref' | 'variant'> & {
  currency?: string;
  variant?: MuiTextFieldProps['variant'];
};

export const CurrencyFormField = ({ helperText, name, currency = 'BRL', ...props }: CurrencyFormFieldProps) => {
  const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
  const meta = getFieldMeta<number>(name);
  const errorText = meta.touched && meta.error;
  const maskedValue = moneyNoSymbolMask.apply(meta.value, currency);

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      return setFieldValue(name, moneyNoSymbolMask.clean(e.target.value, currency));
    },
    [setFieldValue, name, currency]
  );

  const onBlurHandler = useCallback(() => {
    setFieldTouched(name, true);
  }, [setFieldTouched, name]);

  return (
    <Hint inputName={name}>
      <TextField
        fullWidth
        helperText={errorText || helperText}
        error={!!errorText}
        name={name}
        value={maskedValue}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        variant='standard'
        {...props}
      />
    </Hint>
  );
};

export default CurrencyFormField;
